module.exports = __webpack_public_path__ + "static/home-banner-2d490151a60cf5a2b636282b88b116ab.svg";